export class Image {
    url: string;

    constructor(url: string) {
        this.url = url
    }
}